import { PropTypes } from 'prop-types';
import React from 'react';

const PermissionsWrapper = ( {
	alt,
	children,
	permission
} ) => {
	if ( !permission ) {
		return alt;
	}

	return (
		<>{ children }</>
	);
};

PermissionsWrapper.propTypes = {
	alt: PropTypes.node,
	children: PropTypes.node,
	permission: PropTypes.bool
};

export default PermissionsWrapper;
